import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  CardHeader,
  CardBody,
  UncontrolledAlert
} from "reactstrap";
import { MdArrowBack } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { AdminVerifiedDashBoard } from "../../../_constants/RouteVariables";
import { publishService } from "../Users/publishedContents/service/publishContents.service";
import TextEditor from "../../Shared/Forms/TextEditor";
import Formsy from "formsy-react";
import { EditorState, ContentState, convertFromHTML } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

class ViewVerifiedContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postId: null,
      postInterest: null,
      postTitle: null,
      postBody: null,
      interestId: null,
      data: null,
      postStatus: null,
      isEdit: false,
      error: null,
      declineComment: null,
      editorState: EditorState.createEmpty(),
      stripPastedStyles: false
    };
  }

  viewValue = data => {
    const editorState = EditorState.createWithContent(
      ContentState.createFromBlockArray(convertFromHTML(data))
    );

    this.setState({ editorState });
  };

  componentDidMount() {
    if (this.props.location.state) {
      const { postId } = this.props.location.state;

      this.getPostsById(postId);
    } else {
      this.setState({ data: null, status: null });
    }
  }

  routeChange = () => {
    let path = "/approvedcontents";
    this.props.history.push(path);
  };

  getPostsById = id => {
    this.setState({ submitting: true });
    publishService
      .getPost(id)
      .then(response => {
        response &&
          this.setState({
            postId: id,
            postInterest: response.interestName,
            postTitle: response.title,
            postBody: response.body,
            interestId: response.interestId,
            postStatus: response.status,
            declineComment: response.reviewerRemarks,
            formError: null,
            submitting: false,
            submitSucessful: true,
            error: null,
            fetching: false,
            isEdit: true
          });
        if (response.status === "PENDING") {
          this.routeChange();
        } else {
          this.viewValue(this.state.postBody);
        }
      })
      .catch(error => this.setState({ error, fetching: false }));
  };

  stopEdit = () => {
    this.setState({
      isEdit: false
    });
  };
  changeDeclineToDraft = id => {
    publishService
      .changePostStatus(id)
      .then(response => {
      
      })
      .catch(error => this.setState({ error, fetching: false }));
  };

  routeChange = () => {
    let path = `/userpublishedcontents`;
    this.props.history.push(path);
  };

  render() {
    const {
    
      postTitle,
      postBody,
      isEdit,
      postStatus,
      error,
      declineComment,

      postInterest
    } = this.state;

    return (
      <div>
        <NavLink to={AdminVerifiedDashBoard}>
          <Button type="button" color="primary" className="mb-2">
            <MdArrowBack />
            <span>Back</span>
          </Button>
        </NavLink>
        {error ? (
          <UncontrolledAlert color="danger">{error.message}</UncontrolledAlert>
        ) : null}
        <Row>
          <Col sm="7">
            <Card>
              <Formsy>
                <TextEditor
                  name="body"
                  value={null}
                  isViewOnly={true}
                  isEdit={isEdit}
                  stopEdit={this.stopEdit}
                  postBody={postBody}
                  toolbarHidden={true}
                  stripPastedStyles={false}
                  postInterest={postInterest}
                  postTitle={postTitle}
                />
              </Formsy>
            </Card>
          </Col>

          {postStatus === "DECLINED" ? (
            <Col>
              <div>
                <Card style={{ marginTop: "1rem" }}>
                  <CardHeader>Decline Comment</CardHeader>
                  <CardBody>
                    <p>{declineComment}</p>
                    <br />
                  </CardBody>
                </Card>
              </div>
            </Col>
          ) : null}
        </Row>
      </div>
    );
  }
}
export default ViewVerifiedContent;
